module.exports = __webpack_public_path__ + "img/influencers_sheet_top@2x.f3e84575.png";